@switch (displayAs()) {
  @case ('default') {
    <div class="p mb-2 w-full basis-full font-bold">
      {{ openingHoursTitle() }}
    </div>
    @for (hour of rows(); track $index) {
      <div class="mb-1 flex w-full basis-full flex-row flex-wrap">
        <div class="p w-1/2 basis-1/2">
          {{ hour.title }}
        </div>
        <div class="p w-1/2 basis-1/2">
          {{ hour.formattedRange }}
        </div>
      </div>
    }
  }
}
